module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "client": _vm.client,
      "useAnimations": _vm.useAnimations,
      "clients": _vm.clients,
      "totalGames": _vm.totalGames,
      "runningInApp": _vm.runningInApp,
      "highscoreRoom": _vm.highscoreRoom,
      "playerName": _vm.playerName,
      "highscores": _vm.highscores,
      "plays": _vm.plays
    },
    on: {
      "closeChangeName": function($event) {
        _vm.shouldSetUserName = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "change-player-name",
    class: {
      'show': _vm.shouldSetUserName
    }
  }, [_vm._v("\n    Enter new name\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.playerName),
      expression: "playerName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "playerName"
    },
    domProps: {
      "value": (_vm.playerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.playerName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.savePlayerName
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "highscore-notification",
    class: {
      'show': _vm.showNotification
    }
  }, [(_vm.notification.rank > -1) ? [_c('div', {
    staticClass: "highscore-rank"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-trophy",
    class: {
      'gold': _vm.notification.rank === 1, 'silver': _vm.notification.rank === 2, 'bronze': _vm.notification.rank === 3
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.showHighscore = true
      }
    }
  }), _vm._v(" " + _vm._s(_vm.notification.rank) + ".\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "highscore-name"
  }, [_vm._v("\n        " + _vm._s(_vm.notification.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "highscore-score"
  }, [_vm._v("\n        " + _vm._s(_vm.notification.score) + "\n      ")])] : _vm._e(), _vm._v(" "), (_vm.notification.rank === -1) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "new-player-message"
  }, [_vm._v("\n        " + _vm._s(_vm.notification.name) + "\n      ")]), _vm._v(" "), _c('div')] : _vm._e()], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-player-icon"
  }, [_c('div', [_c('i', {
    staticClass: "fas fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-327a9626","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 110
// module chunks = 1